'use strict';

define(['plugins/utils', 'plugins/plugin'], function (pluginsUtils, Plugin) {

    var PluginModel = function PluginModel(plugins) {
        this.addPlugin = function (url) {
            var pluginName = pluginsUtils.getPluginName(url);
            if (!plugins[pluginName]) {
                plugins[pluginName] = new Plugin(url);
            }
            return plugins[pluginName];
        };

        this.getPlugins = function () {
            return plugins;
        };
    };

    return PluginModel;
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/plugins/model.js
 ** module id = 95
 ** module chunks = 0
 **/